import React from 'react';
import { Card, CardBody, CardTitle, Spinner, Table } from 'reactstrap';
import { EditProfileButton } from '../../../containers/Buttons';

const ProfileInfoCardComponent = (props: {
  displayName: string;
  firstName: string;
  familyName: string;
  gender: string;
  email: string;
  loading?: boolean;
}) => (
  <Card>
    <CardBody>
      {!props.loading ? (
        <>
          <EditProfileButton className="float-right" />
          <CardTitle>
            <h3>{props.displayName}</h3>
          </CardTitle>
          <Table>
            <tbody>
              <tr>
                <td>
                  <b>First Name</b>
                </td>
                <td>{props.firstName}</td>
              </tr>
              <tr>
                <td>
                  <b>Last Name</b>
                </td>
                <td>{props.familyName}</td>
              </tr>
              <tr>
                <td>
                  <b>Gender</b>
                </td>
                <td>{props.gender}</td>
              </tr>
              <tr>
                <td>
                  <b>Email</b>
                </td>
                <td>{props.email}</td>
              </tr>
            </tbody>
          </Table>
        </>
      ) : (
        <Spinner></Spinner>
      )}
    </CardBody>
  </Card>
);
export default ProfileInfoCardComponent;
